module.exports = __webpack_public_path__ + "media/images/btn_update-d5b2ea348079408aa1b8cf5c133e51a8.gif";